module.exports = __webpack_public_path__ + "media/images/icons/new_phone-9c6f6bb3633bff3a1725d562c8c506f1.svg";